import { useEffect, useReducer } from 'react';
import { __INTERNAL__ } from '@data-client/react';

import type {
  AsyncConnector,
  AsyncConnectorView,
} from '../classes/async-connector';

const { useCacheState } = __INTERNAL__;

/**
 * Bind a store-derived `AsyncConnector` to React. The rows are READ FROM the
 * Data Client store: `useCacheState` re-renders on every store commit (so a
 * normal `Api.write` that merged into the same entities shows up with no
 * refetch), and the connector's own `subscribe` re-renders on paging/meta
 * changes (reload / loadMore). Returns the connector's derived view; the
 * consumer drives fetching via `connector.reload()` / `connector.loadMore()`.
 */
export const useAsyncConnectorList = <AsyncConnectorResult, Row>(
  connector: AsyncConnector<AsyncConnectorResult, Row>
): AsyncConnectorView<Row> => {
  const state = useCacheState();
  const [, forceRender] = useReducer((count: number) => count + 1, 0);

  useEffect(() => connector.subscribe(forceRender), [connector]);

  return connector.getView(state);
};
